import React from 'react';

import Unsubscribers from '../../components/Communication/Unsubscribers';

function UnsubscribersView() {
  return (
    <Unsubscribers />
  );
}

export default UnsubscribersView;


